module.exports = __webpack_public_path__ + "static/wuli2020-9e8f737582e0dc9710a9f865f4a91175.jpg";